import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { Companyid, DROPDOWN_CONFIG, USER_SUBMENU_ID, TENANT_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class MenuItemMealPeriod extends Component {
    state = {
        roles: [],
        type: 'add',
        Id: null,
        MenuItemMealPeriodId: '',
        MenuItemId: '',
        mealPeriodId: '',
        mealPeriodOptions: [],
        isActive: true,
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    // componentDidMount() {
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);
    //     let id = this.props.match.params.id;
    //     this.props.getMasterTableList('GeUsers?id=' + id);
    //     this.props.getMasterKeywordList('Role');
    //     this.props.getMasterKeywordList('Employee');
    //     this.props.getMasterKeywordList('ApprovalRole');
    //     let type = this.props.match.params.type;

    //     axios.get('/master/api/DropDownValues/FRole')
    //         .then(response => {
    //             if (response.status === 200) {
    //                 let data = []
    //                 if (response.data && response.data.length > 0) {
    //                     data = response.data.map(list => {
    //                         let value = list.id;
    //                         let id = list.id;
    //                         let text = list.text
    //                         return { label: text, value: value.toString(), id: id };
    //                     })
    //                 }
    //                 this.setState({ functionalRoleOptions: data })
    //             }
    //         }
    //         )
    //         .catch(err => {
    //             this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
    //         })

    //     if (type !== 'add') {
    //         this.timer();
    //     }
    // }
    componentDidMount() {
        const id = this.props.match.params.id;
        const type = this.props.match.params.type;

        console.log("ID :", id);
        console.log("TYPE :", type);

        this.setState({ type });

        this.props.getMasterKeywordList("MenuItem");

        axios.get('/master/api/res/GetresMealPeriodList?companyId=' + this.state.CompanyId)
            .then(response => {
                if (response.status === 200) {
                    let data = [];
                    if (response.data && response.data.length > 0) {
                        data = response.data.map(list => {
                            return { label: list.mealPeriodName, value: list.mealPeriodId.toString(), id: list.mealPeriodId };
                        })
                    }
                    this.setState({ mealPeriodOptions: data });
                }
            })
            .catch(err => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Meal Period List Api Failed' });
            })

        if (type !== "add") {
            this.props.getMasterTableList(
                `res/GetResMenuItemMealPeriodById?menuItemMealPeriodId=${id}`,
                this.state.CompanyId
            );
        }
    }

    // componentDidMount() {
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);
    //     let id = this.props.match.params.id;
    //     let type = this.props.match.params.type;
    //     this.setState({ type: type });



    //     if (type !== "add") {
    //         this.props.getMasterTableList(
    //             `res/GetTenantbyid?TypeId=${id}`,
    //             this.state.CompanyId
    //         );
    //     }
    // }

    componentDidUpdate(prevProps) {

        if (this.props.tableLists !== prevProps.tableLists) {
            console.log("API Response:", this.props.tableLists);

            const MealPeriod = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            if (!MealPeriod) return;

            this.setState({
                // Id: Tenant.id,
                CompanyId: MealPeriod.companyId || "",
                MenuItemMealPeriodId: MealPeriod.menuItemMealPeriodId || "",
                MenuItemId: MealPeriod.menuItemId || "",
                mealPeriodId: MealPeriod.mealPeriodId || "",
                isActive: MealPeriod.isActive,


            });
        }
    }

    // timer = () => {
    //     this.intervalID = setInterval(() => {
    //         this.fetchSingleProcess();
    //     }, 2000)
    // }
    // componentWillUnmount() {
    //     if (this.props.tableLists.usersList !== undefined) {
    //         clearInterval(this.intervalID);
    //     }
    // }

    // fetchSingleProcess = () => {

    //     let id = this.props.match.params.id;
    //     let type = this.props.match.params.type;
    //     let storageItems = [];
    //     if (this.props.tableLists.usersList !== undefined) {
    //         storageItems = this.props.tableLists.users;
    //         clearInterval(this.intervalID);
    //     }
    //     if (storageItems) {
    //         let filterData = storageItems;
    //         if (filterData) {
    //             let roles = '';
    //             let functionalRoles = '';
    //             let approvalroles = '';
    //             if (filterData.roleAssigned != null) {
    //                 roles = filterData.roleAssigned.split(",")
    //             }
    //             if (filterData.functionalRole != null) {
    //                 functionalRoles = filterData.functionalRole.split(",")
    //             }
    //             if (filterData.approvalrole != null) {
    //                 approvalroles = filterData.approvalrole.split(",")
    //             }
    //             var data = {
    //                 type: type,
    //                 Id: filterData.id,
    //                 UserId: filterData.userId,
    //                 EmployeeId: filterData.employeeId,
    //                 RoleId: roles,
    //                 approvalRoleId: approvalroles,
    //                 UserId1: filterData.userid1,
    //                 FirstName: filterData.firstName,
    //                 functionalRoleId: functionalRoles,
    //                 MiddleName: filterData.middleName,
    //                 LastName: filterData.lastName,
    //                 EmailId: filterData.emailId,
    //                 Password: filterData.password,
    //                 MobileNumber: filterData.mobileNumber,
    //                 Activedirectory: filterData.activedirectory,
    //                 Adloginid: filterData.adloginid,
    //                 Disablelogin: filterData.disablelogin,
    //                 IsActive: filterData.isActive,
    //                 CreatedBy: filterData.createdby,
    //                 CreatedDate: filterData.createddate,
    //             }
    //             this.setState(data);

    //         }
    //     }

    // }


    // change = (e) => {
    //     let { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true })

    // }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onDropdownChange = (e) => {
        this.setState({
            [e.target.name]: e.value,
            touch: true
        });
    }



    add = () => {

        if (this.state.MenuItemId === null || this.state.MenuItemId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Menu Item is required' });
            return;
        } else if (this.state.mealPeriodId === null || this.state.mealPeriodId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Meal Period is required' });
            return;
        }
        var data = {
            companyId: this.state.CompanyId,
            menuItemId: this.state.MenuItemId,
            mealPeriodId: this.state.mealPeriodId,
            isActive: this.state.isActive,
        }


        if (this.state.type === 'edit') {
            data.menuItemMealPeriodId = this.state.MenuItemMealPeriodId;
        }

        // this.props.processDynamicData('user', this.state.type, data, 'GeUsers');
        this.props.processDynamicData('ResMenuItemMealPeriod', this.state.type, data, 'res/GetResMenuItemMealPeriodById?' + Companyid);


    }

    resetData = () => {
        var data = {
            type: 'add',
            Id: null,
            MenuItemMealPeriodId: '',
            MenuItemId: '',
            mealPeriodId: '',
            isActive: true,
            // CompanyId: this.props.loggedUserDetail.CompanyId,
            touch: false
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/menuitemmealperiod/', this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/menuitemmealperiod/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }


        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add Menu Item Meal Period</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Menu Item <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Menu Item" options={this.props.MenuItem} value={String(this.state.MenuItemId)} name="MenuItemId" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Meal Period <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Meal Period" options={this.state.mealPeriodOptions} value={String(this.state.mealPeriodId)} name="mealPeriodId" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.isActive} onChange={this.change} name="isActive" disabled={this.state.type === 'view'} />
                                </div>
                            </div>
                            <div className="p-col-12 p-lg-12">

                                {/* <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to={redirectURL} /> */}

                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === "view"}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/menuitemmealperiod/"
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
        TBS_TYPE: (state.keyword.TBS_TYPE !== undefined) ? state.keyword.TBS_TYPE : [],
        Country: (state.keyword.Country !== undefined) ? state.keyword.Country : [],
        MenuItem: (state.keyword.MenuItem !== undefined) ? state.keyword.MenuItem : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuItemMealPeriod);